import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import '../view-all-button.css';

function ViewAllButton({to, label = 'View all'}) {
  return (
    <Link to={to} className="view-all-button" aria-label={`${label} services`}>
      <span className="view-all-label">{label}</span>
      <span className="view-all-icon" aria-hidden="true">
        <SafeIcon name="ArrowUpRight" focusable="false" />
      </span>
    </Link>
  );
}

export default ViewAllButton;